import { MessageBase, MessageType } from "../Utils/PopupMessage";
import { IUpdatableItem } from "../Utils/UpdatableItemManager";
import { TIMER } from "./Gameplay";
import { Game } from "../Game";



export class ScorePopup extends MessageBase implements IUpdatableItem {
    private static _MSG_TYPE: MessageType;
    private static _ENTITY_CLONE_TEMP: pc.Entity;

    private _entity: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        super();

        if (!ScorePopup._ENTITY_CLONE_TEMP) {
            ScorePopup._ENTITY_CLONE_TEMP = this.createEntity(Game.APP);
            this._entity = ScorePopup._ENTITY_CLONE_TEMP;

            ScorePopup._MSG_TYPE = new MessageType(0.75, 800, pc.CubicOut, 700, 300, pc.CubicOut);
        }
        else {
            this._entity = ScorePopup._ENTITY_CLONE_TEMP.clone();
        }

        Game.APP.root.addChild(this._entity);
        this._entity.enabled = false;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(x: number, y: number, z: number, text: string): ScorePopup {
        this._entity.element.text = text;
        this._entity.setPosition(x, y, z);
        this._entity.enabled = true;

        super.showMessage(x, y, ScorePopup._MSG_TYPE, TIMER);

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): boolean {
        let res = super.update();

        return res;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    release(): IUpdatableItem {
        super.release();
        this._entity.enabled = false;

        return this;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    protected updateContainer(x: number, y: number): void {
        this._entity.setPosition(x, y, this._entity.getPosition().z);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createEntity(app: pc.Application): pc.Entity {
        let e = new pc.Entity("scorePopup");
        e.enabled = false;

        // Pridat text element
        e.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_TEXT,
            fontSize: 0.18,
            fontAsset: app.assets.find("fntDefault", pc.eAssetType.font).id,
            autoWidth: true,
            autoHeight: true,
            pivot: [0.5, 0.5],
        });

        e.element.shadowColor.set(0, 0, 0, 1);
        e.element.shadowOffset.set(1, -1);

        return e;
    }
}